import { useEffect } from "react";
import { renderTurnstile } from "../api/utils";

export function useTurnstile() {
  useEffect(() => {
    return renderTurnstile()
  }, []);
}
